require('./detectUserAgent');



// WEBPACK FOOTER //
// ./src/scripts/utils/index.js